import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SelectSala from '../views/SelectSala.vue'
import ArrecadacaoSala from '../views/ArrecadacaoSala.vue'
import Resultado from '../views/Resultado.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/metas/:classe?',
    name: 'Home',
    component: Home,
    // Validar o parâmetro da classe usando uma expressão regular
  },
  {
    path: '/selecione',
    name: 'SelectSala',
    component: SelectSala
  },
  {
    path: '/resultado',
    name: 'Resultado',
    component: Resultado
  },
  {
    path: '/arrecadacao-sala/:classe',
    name: 'ArrecadacaoSala',
    component: ArrecadacaoSala,
        
      },
  {
    // Rota para lidar com URLs não encontradas
    path: '*',
    redirect: '/selecione'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
